import { Column, Heading, Row, TruncatedText } from "@hex-insights/core";
import { Badge } from "../../../../../Components/Badge";
import { DetailFormModalController } from "../../../../../Components/DetailFormModal";
import { Icon } from "../../../../../Components/Icon";
import { AcademicTermDetailQuery, useAcademicTermsPreviousAndNextQuery } from "../../../../../Utilities";
import { AcademicTermFormat } from "../../../../Format";
import { AcademicTermForm } from "../../../../Forms";
import { AcademicTermLink } from "../../../../Links";

export type HeaderProps = {
	academicTerm: AcademicTermDetailQuery["academicTerm"];
};

export function Header({ academicTerm }: HeaderProps) {
	return (
		<Row justify="space-between" align="center">
			<Column justify="spaced-start">
				<Heading.H1 noMargin>{AcademicTermFormat.name(academicTerm)}</Heading.H1>

				<Row justify="spaced-start" align="center" style={{ padding: "0 1rem" }}>
					<Badge color="#fff" backgroundColor="var(--theme-colors__blue)">
						<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
							<Icon.CalendarBlank size={14} />
							<TruncatedText>
								{AcademicTermFormat.Fields.startDate(academicTerm.startDate)} to{" "}
								{AcademicTermFormat.Fields.endDate(academicTerm.endDate)}
							</TruncatedText>
						</Row>
					</Badge>

					<AcademicTermNavigation academicTerm={academicTerm} />
				</Row>
			</Column>

			<DetailFormModalController
				heading="Edit Academic Term"
				DetailForm={AcademicTermForm.ControlledDetail}
				instanceName="academicTerm"
				instance={academicTerm}
			/>
		</Row>
	);
}

type AcademicTermNavigationProps = {
	academicTerm: AcademicTermDetailQuery["academicTerm"];
};

function AcademicTermNavigation({ academicTerm }: AcademicTermNavigationProps) {
	const { data } = useAcademicTermsPreviousAndNextQuery({
		variables: { id: academicTerm.id, date: academicTerm.startDate },
	});
	const prev = data?.previous.edges[0]?.node;
	const next = data?.next.edges[0]?.node;

	return (
		<Row justify="spaced-start" horizontalSpacing="0.25rem">
			<AcademicTermLink instance={prev ?? academicTerm} className="link--no-text-decoration">
				<Badge
					color="#fff"
					backgroundColor={!!prev ? "var(--theme-colors__green)" : "var(--neutral-colors--tertiary-point-two-five)"}
				>
					<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
						<Icon.CaretLeft size={14} />
						<TruncatedText>Previous</TruncatedText>
					</Row>
				</Badge>
			</AcademicTermLink>
			<AcademicTermLink instance={next ?? academicTerm} className="link--no-text-decoration">
				<Badge
					color="#fff"
					backgroundColor={!!next ? "var(--theme-colors__green)" : "var(--neutral-colors--tertiary-point-two-five)"}
				>
					<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
						<TruncatedText>Next</TruncatedText>
						<Icon.CaretRight size={14} />
					</Row>
				</Badge>
			</AcademicTermLink>
		</Row>
	);
}
